export default "__VITE_ASSET__F2ZyzdEz__"